



































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Branch, Company, Terminal, VueForm } from "@/domain";
import QuickSnack from "@/components/QuickSnack.vue";
import MoneyField from "@/components/MoneyField.vue";
import NumberField from "@/components/NumberField.vue";
import Upload from "@/components/Upload.vue";
import AvatarRef from "@/components/AvatarRef.vue";
import VendingTopayMessages from "./VendingTopayMessages.vue";
import VendingTopayClearMessages from "./VendingTopayClearMessages.vue";
import VendingConfigCopy from "@/components/VendingConfigCopy.vue";
import VendingExecuteCommand from "@/components/VendingExecuteCommand.vue";
import * as util from "@/util";
import {
  ExtraData,
  ForceConfigPricesData,
  OperationMode,
  VendingConfig,
  VendingConfigOptions,
  VendingProduct
} from "@/domain/api";
import { executeForceConfigPrices, saveVendingConfig } from "@/domain/backend/vending";
import { newVendingConfig, prepareVendingConfigForSave } from "@/domain/vending";
import { logError } from "@/util";

type CardPaymentValue = "disabled" | "preauthorization" | "saleReturn";
type SaleModeValue = "normal" | "alwaysIdle" | "initialPreauthorization";
type PricesInMachine = "pricesInMachine" | "customPrices" | "pricesInMachineDTS" | "priceGrouping";

@Component({
  components: {
    QuickSnack,
    MoneyField,
    NumberField,
    Upload,
    AvatarRef,
    VendingTopayMessages,
    VendingConfigCopy,
    VendingExecuteCommand,
    VendingTopayClearMessages
  }
})
export default class VendingTerminalConfig extends Vue {
  @Prop() vendingOptions!: VendingConfigOptions | null;
  @Prop() branch!: Branch | null;
  @Prop() terminal!: Terminal | null;
  @Prop({ default: newVendingConfig(0, 0, "", "") }) config!: VendingConfig | null;
  activeSaving = false;
  showForcePricesDialog = false;
  showForceConfigDialog = false;
  dialogExtraData = false;
  topayExtraData: ExtraData | null = null;
  topayExtraDataKeys: string[] | null = null;
  editedProduct: VendingProduct | null = null;
  // SHOW ACTION BTNS
  showActions = false;

  // CONFIRM SAVE
  showConfirmSaveDialog = false;
  confirmSaveTxt = "";

  get userCompanies(): Company[] {
    return this.$store.state.userCompanies || [];
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  get snackbar() {
    return this.$refs.snackbar as QuickSnack;
  }

  get hasProducts() {
    if (this.config && this.config.products.length > 0) return true;
    return false;
  }

  get executeCommandArgs() {
    return {
      branchID: this.branch?.id ?? null,
      userUID: this.$store.state.currentUser?.uid ?? null,
      tcod: this.config?.TCOD ?? null
    };
  }

  get languageOptions() {
    return this.vendingOptions?.languages ?? [];
  }

  get topayQRCameraOptions() {
    return this.vendingOptions?.topayOptions?.qrCameraTypes ?? [];
  }

  get topayQROptions() {
    return this.vendingOptions?.topayOptions?.qrTypes ?? [];
  }

  get topayRead() {
    return this.vendingOptions?.topayOptions?.readTypes ?? [];
  }

  get topayUrls() {
    return this.vendingOptions?.topayOptions?.topayUrls ?? [];
  }

  get topayVisibleCreditOptions() {
    return this.vendingOptions?.topayOptions?.creditOptions ?? [];
  }

  get printerTypes() {
    return this.vendingOptions?.printerTypes ?? [];
  }

  get printerPaperWidths() {
    return this.vendingOptions?.printerPaperWidths ?? [];
  }

  get cardPaymentOptions() {
    return [
      { text: "Deshabilitado", value: "disabled" },
      { text: "Preautorización", value: "preauthorization" },
      { text: "Venta / Devolución", value: "saleReturn" }
    ];
  }

  get saleModeOptions() {
    return [
      { text: "Normal", value: "normal" },
      { text: "Always Idle", value: "alwaysIdle" },
      {
        text: "Preautorización Inicial",
        value: "initialPreauthorization",
        disabled: this.cardPaymentValue != "preauthorization"
      }
    ];
  }

  get enabledByInputSignalOptions() {
    return this.vendingOptions?.pulseMode?.inputSignalOptions ?? [];
  }

  get lineOffsetOptions() {
    return this.vendingOptions?.lineOffsets ?? [];
  }

  get machineAmount() {
    return [
      { text: "Precios en máquina", value: "pricesInMachine" }, // pricesInMachine = true / updateMachinePrices = false (oculta tabla precios)
      { text: "Precios personalizados", value: "customPrices" }, // pricesInMachine = false / updateMachinePrices = false
      { text: "Precios actualizados por DTS", value: "pricesInMachineDTS" }, // pricesInMachine = true / updateMachinePrices = true
      { text: "Agrupación de precios", value: "priceGrouping" } // pricesInMachine = true, updateMachinePrices = false
    ];
  }
  get operationModeOptions() {
    return this.vendingOptions?.operationModes ?? [];
  }

  get cashlessOptions() {
    return this.vendingOptions?.cashlessTypes ?? [];
  }

  get productSelectionPolicyOptions() {
    return this.vendingOptions?.pulseMode?.productSelectionPolicies ?? [];
  }

  get baseCoinOptions() {
    return this.vendingOptions?.baseCoinOptions ?? [];
  }

  get disableSave() {
    if (!this.config) return true;
    if (this.config.topay && this.config.topayConfig && this.config.topayConfig.rechargePredefinedAmounts) {
      if (this.config.topayConfig.rechargePredefinedAmounts.length > 4) {
        return true;
      }
    }
    return false;
  }

  get cardPaymentValue(): CardPaymentValue | null {
    const cf = this.config?.mdbSlaveConfig;
    if (!cf) return null;
    if (cf.cardPaymentEnabled === false) return "disabled";
    if (cf.usesSale) return "saleReturn";
    return "preauthorization";
  }

  set cardPaymentValue(cv: CardPaymentValue | null) {
    const cf = this.config?.mdbSlaveConfig;
    if (!cf) return;
    switch (cv) {
      case "disabled":
        cf.cardPaymentEnabled = false;
        cf.usesSale = false;
        cf.initialPreauth = false;
        break;
      case "saleReturn":
        cf.cardPaymentEnabled = true;
        cf.usesSale = true;
        cf.initialPreauth = false;
        break;
      case "preauthorization":
      default:
        cf.cardPaymentEnabled = true;
        cf.usesSale = false;
        break;
    }
  }

  get pricesInMachineValue(): PricesInMachine | null {
    const cf = this.config?.mdbSlaveConfig;
    if (!cf) return null;
    if (cf.pricesInMachine && !cf.updateMachinePrices && !cf.lineGrouping) return "pricesInMachine";
    if (!cf.pricesInMachine && !cf.updateMachinePrices && !cf.lineGrouping) return "customPrices";
    if (cf.pricesInMachine && cf.updateMachinePrices && !cf.lineGrouping) return "pricesInMachineDTS";
    if (cf.pricesInMachine && !cf.updateMachinePrices && cf.lineGrouping) return "priceGrouping";
    return null;
  }

  set pricesInMachineValue(pim: PricesInMachine | null) {
    const cf = this.config?.mdbSlaveConfig;
    if (this.config) this.config.products = [];
    if (!cf) return;
    switch (pim) {
      case "pricesInMachine":
        cf.pricesInMachine = true;
        cf.updateMachinePrices = false;
        cf.lineGrouping = false;
        break;
      case "customPrices":
        cf.pricesInMachine = false;
        cf.updateMachinePrices = false;
        cf.lineGrouping = false;
        break;
      case "pricesInMachineDTS":
        cf.pricesInMachine = true;
        cf.updateMachinePrices = true;
        cf.lineGrouping = false;
        break;
      case "priceGrouping":
        cf.pricesInMachine = true;
        cf.updateMachinePrices = false;
        cf.lineGrouping = true;
        break;
      default:
        logError(`Invalid price value ${pim}`);
        break;
    }
  }

  get saleModeValue(): SaleModeValue | null {
    const cf = this.config?.mdbSlaveConfig;
    if (!cf) return null;
    if (cf.alwaysIdle) return "alwaysIdle";
    if (cf.initialPreauth) return "initialPreauthorization";
    return "normal";
  }

  set saleModeValue(sv: SaleModeValue | null) {
    const cf = this.config?.mdbSlaveConfig;
    if (!cf) return;
    switch (sv) {
      case "alwaysIdle":
        cf.alwaysIdle = true;
        cf.initialPreauth = false;
        break;
      case "initialPreauthorization":
        if (cf.usesSale) {
          this.$nextTick(() => {
            this.saleModeValue = "normal";
            this.$forceUpdate();
          });
        } else {
          cf.initialPreauth = true;
          cf.alwaysIdle = false;
        }
        break;
      case "normal":
      default:
        cf.initialPreauth = false;
        cf.alwaysIdle = false;
        break;
    }
  }

  get isModeMdbSlave() {
    return this.config?.operationMode === OperationMode.MDBSlave; // 2
  }

  get isModePulse() {
    return this.config?.operationMode === OperationMode.Pulse; // 3
  }

  get isModeRecharger() {
    return this.config?.operationMode === OperationMode.Recharger; // 4
  }

  get amountRules() {
    return [
      //util.rules.required("Ingrese un valor"),
      (value: unknown) => util.toNumberSafe(value) >= 0 || this.lang.ruleValueMin0,
      (value: unknown) => util.toNumberSafe(value) <= 500 || this.lang.ruleValueMAx500
    ];
  }

  get requiredRules() {
    return [util.rules.required(this.lang.ruleRequiredValue)];
  }

  @Watch("config")
  onConfigChanged() {
    this.showTopayMessages(false);
    this.showTopayClearMessages(false);
  }

  showTopayMessages(visible: boolean) {
    (this.$refs["dg-topay-messages"] as VendingTopayMessages).setVisible(visible);
  }

  showTopayClearMessages(visible: boolean) {
    (this.$refs["topay-messages-clear"] as VendingTopayClearMessages).setVisible(visible);
  }

  onSelTerminal() {
    this.$emit("refresh-terminal");
  }

  async executeForceConfigPrices(type: "config" | "prices") {
    const tcod = this.config?.TCOD;
    const branchID = this.config?.branchID;
    if (!tcod || !branchID) return this.snackbar.show("Error: Invalid TCOD", "error");
    const data: ForceConfigPricesData = {
      branchID,
      tcod,
      type
    };
    try {
      const response = await executeForceConfigPrices(data);
      if (response.saved) this.snackbar.show(this.lang.forceSuccess, "success");
      else this.snackbar.show(this.lang.forceFailed + type + " - " + response.message, "error");
    } catch (err) {
      this.snackbar.show(this.lang.forceFailed + type + " - " + (err as Error).message, "error");
    } finally {
      this.showForcePricesDialog = false;
      this.showForceConfigDialog = false;
    }
  }

  addProduct() {
    this.config?.products.push({
      lineNumber: 1,
      name: "",
      cashPrice: 0,
      cardPrice: 0,
      pulseCount: 1,
      enabled: true
    });
  }

  removeProduct(idx: number) {
    this.config?.products.splice(idx, 1);
  }

  getRowsNumber(text: string): number {
    let count = 1;
    if (text) count = text.split("\n")?.length + 1;
    return count;
  }

  showExtraData(extraData: ExtraData) {
    this.topayExtraData = extraData || null;
    if (this.topayExtraData) {
      this.topayExtraDataKeys = Object.keys(this.topayExtraData);
      this.dialogExtraData = true;
    }
  }

  getHint(value: number, min = 1000) {
    if (!value || value < min) return this.lang.minValueHint;
    else return "";
  }

  getRechargePredefinedHint(value: Array<string | number>) {
    let allNumbers = true;
    // validate float inputs.
    value.map((e) => {
      if (typeof e != "number") allNumbers = false;
    });
    if (!allNumbers) {
      const values: Array<number> = [];
      value.map((e) => {
        if (typeof e == "number") values.push(e);
        else values.push(parseInt(e));
      });
      if (this.config && this.config.topayConfig) this.config.topayConfig.rechargePredefinedAmounts = values;
    }
    if (value.length > 4) {
      return this.lang.predefinedChargeHint;
    } else return "";
  }

  showExecuteCommand() {
    (this.$refs["cp-execute-command"] as VendingExecuteCommand).show();
  }

  showConfigCopy() {
    (this.$refs["cp-config-copy"] as VendingConfigCopy).show();
  }

  onConfigCopied(data: { config: VendingConfig }) {
    this.$emit("config-copied", { config: data.config });
  }

  scrollToFirstError() {
    document.querySelector(".error--text")?.scrollIntoView();
    window.scrollBy(0, -70);
  }
  checkEnabledProducts(products: VendingProduct[] | null | undefined): boolean {
    if (!products) return false;
    let enabled = false;
    products.forEach((p) => {
      if (p.enabled) enabled = true;
    });
    return enabled;
  }

  cmdSaveTerminalConfirm() {
    const enabledPrices = this.checkEnabledProducts(this.config?.products);
    if (!this.config) return;
    if (this.config.mdbSlaveConfig) {
      // si modo personalizado y tabla precios vacia o dashabilitados mostrar modal de confirmación
      // Precios personalizados --> pricesInMachine = false / updateMachinePrices = false
      if (
        this.config.operationMode === 2 &&
        !this.config.mdbSlaveConfig.pricesInMachine &&
        !this.config.mdbSlaveConfig.updateMachinePrices &&
        !enabledPrices
      ) {
        this.confirmSaveTxt = this.lang.priceTableWarning1;
        this.showConfirmSaveDialog = true;
        return;
      }

      // si modo Precios actualizados por DTS.
      // Precios actualizados por DTS --> pricesInMachine = true / updateMachinePrices = true
      if (
        this.config.operationMode === 2 &&
        this.config.mdbSlaveConfig.pricesInMachine &&
        this.config.mdbSlaveConfig.updateMachinePrices &&
        !enabledPrices
      ) {
        this.confirmSaveTxt = this.lang.priceTableWarning2;
        this.showConfirmSaveDialog = true;
        return;
      }
    }

    this.cmdSaveTerminal();
  }

  async cmdSaveTerminal() {
    const form = this.$refs.vendingForm as VueForm;
    if (form.validate()) {
      try {
        this.activeSaving = true;
        if (this.config) {
          const configToSave = prepareVendingConfigForSave(this.config);
          util.log("Saving configuration", { v: configToSave });
          const result = await saveVendingConfig(configToSave);
          util.log("Save result", { result });
          if (result.saved) {
            this.snackbar.show(this.lang.successfulSave, "success");
            await this.onSelTerminal();
          } else {
            this.snackbar.show(`Error: ${result.message}`, "error");
          }
        }
      } catch (ex) {
        util.logError("Error saving terminal", { ex });
        this.snackbar.show(this.lang.errorSaving + (ex as Error).message, "error");
      }
    } else {
      this.scrollToFirstError();
      this.snackbar.show(this.lang.errorInvalidFields, "error");
    }
    this.activeSaving = false;
  }
}
